import { useQuery } from "react-query";
import { workspaceScopedQueryKey } from "../utils/workspaceQueryScope";

/** Catálogos de filtro mudam pouco — evita spinner/DB a cada abertura do modal. */
export const FILTER_OPTIONS_STALE_MS = 10 * 60 * 1000;
export const FILTER_OPTIONS_CACHE_MS = 30 * 60 * 1000;

/**
 * Cache compartilhado (por workspace) para opções de filtros avançados.
 * `isLoading` só fica true na primeira carga sem cache — reabrir o modal não mostra spinner.
 */
export function useCachedFilterOptions(
  cacheKey,
  fetcher,
  { enabled = true, staleTime = FILTER_OPTIONS_STALE_MS, cacheTime = FILTER_OPTIONS_CACHE_MS } = {}
) {
  return useQuery(workspaceScopedQueryKey("filter-options", cacheKey), fetcher, {
    enabled: Boolean(enabled),
    staleTime,
    cacheTime,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    retry: 1,
  });
}
